import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from '../../pages/login/Login';
import Registration from '../../pages/registration/Registration';
import VerificationExpired from '../../pages/registration/VerificationExpired';
import RegistrationSuccess from '../../pages/registration/Success';
import ForgotPassword from '../../pages/forgot-password/ForgotPassword';
import ForgotPasswordSuccess from '../../pages/forgot-password/Success';
import ResetPassword from '../../pages/reset-password/ResetPassword';
import ActivateAccount from '../../pages/activate-account/ActivateAccount';

const UnauthorizedRoutes = () => (
  <Switch>
    <Route path="/login" component={Login} />
    <Route path="/registration" exact component={Registration} />
    <Route path="/registration/success" component={RegistrationSuccess} />
    <Route
      path="/registration/verification-expired"
      component={VerificationExpired}
    />
    <Route path="/forgot-password" exact component={ForgotPassword} />
    <Route path="/forgot-password/success" component={ForgotPasswordSuccess} />
    <Route path="/reset-password" component={ResetPassword} />
    <Route path="/activate-account" component={ActivateAccount} />
    <Redirect to="/login" />
  </Switch>
);

export default UnauthorizedRoutes;
